<script>
import colors from '../../../pcp/wom'

const Performance = {
    id: null,
    hash: null,
    is_heading: false,
    is_footer: false,
    name: null,
    number: '',
    weight: 0,
    target: null,
    target_monthly: 0,
    target_ongoing: 0,
    total_target: 0,
    total_yield: 0,
    min_achievement: null,
    percentage_month: 0,
    percentage_project: 0,
    predicate: 1,
    wom: {},
    achievement: { status: 'waiting', target_yield: 0, total_yield: 0 }
}
const perspectives = {
    FIN: 'Financial',
    CUF: 'Customer Focus',
    BUI: 'Business Internal',
    LNG: 'Learning & Growth'
}

const columns = [
    {
        key: 'no',
        align: 'center',
        width: 60,
        title: 'No',
        scopedSlots: {customRender: 'number'}
    }, {
        key: 'kpi',
        align: 'center',
        width: 300,
        title: '',
        scopedSlots: {customRender: 'kpi'},
    }, {
        key: 'weight',
        align: 'center',
        title: 'Bobot',
        width: 80,
        scopedSlots: {customRender: 'weight'},
    }, {
        key: 'target',
        align: 'center',
        title: 'Target Selama Masa Project Assignment',
        scopedSlots: {customRender: 'target'},
    }, {
        key: 'monthly_target',
        align: 'center',
        title: 'Target s.d Bln Laporan',
        width: 150,
        scopedSlots: {customRender: 'monthly_target'},
    }, {
        key: 'current_realization',
        align: 'center',
        title: 'Realisasi s.d Bln Laporan',
        width: 150,
        scopedSlots: {customRender: 'current_realization'},
    }, {
        key: 'percentage_project',
        align: 'center',
        title: 'Pencapaian Project',
        width: 110,
        scopedSlots: {customRender: 'percentage_project'},
    }, {
        key: 'percentage_month',
        align: 'center',
        title: 'Pencapaian Bulan',
        width: 110,
        scopedSlots: {customRender: 'percentage_month'},
    }, {
        key: 'predicate',
        align: 'center',
        title: 'Predikat',
        width: 100,
        scopedSlots: {customRender: 'predicate'},
    }, {
        key: 'action',
        align: 'center',
        title: 'Action',
        width: 100,
        scopedSlots: {customRender: 'action'},
    }
]
const aspects = {
    BRE: 'Business Result',
    BPR: 'Business Process'
}

export default {
    props: {
        aspect: {
            type: String,
            default: 'BRE'
        },
        perspective: {
            type: String,
            default: 'FIN'
        },
        user_hash: {
            type: String,
            default: null
        },
        is_scoring: {
            type: Boolean,
            default: false
        },
        showFilter: {
            type: Boolean,
            default: true
        },
        excludes: {
            type: Array,
            default: () => []
        },
        period: {
            type: String,
            default: null
        },
    },
    computed: {
        title() {
            return this.aspect === 'BRE' ? 'Business Result' : 'Business Process'
        },
        catCode() {
            return ['PRF', this.aspect, this.filters.perspective].join('-')
        },
        tableData() {
            if (this.objectives.length > 0) {
                let idx = 0, collection = [], heading = 0, number = 0, vm = this
                let curr = this.filters.month === null ?  this.defaultMonth : this.filters.month
                let keyResult = ''

                this.objectives.forEach(function (item, index) {

                    idx++
                    if (heading !== item.indicator.name) {
                        keyResult = item.indicator.name
                        collection.push(Object.assign(Object.create(Performance), {
                            id: idx,
                            is_heading: true,
                            name: item.indicator.name,
                        }))

                        number = 0
                        heading = item.indicator.name
                        idx++
                    }

                    let achievement = _.has(vm.achievements, item.hash)
                        ? _.find(vm.achievements[item.hash], {month: vm.currentSelectedMonth.format('YYYYMM')})
                        : { status: 'waiting', target_yield: 0, total_yield: 0, file_path: null, evaluation: 0 }

                    number++

                    collection.push(Object.assign(Object.create(Performance), {
                        id: idx,
                        index,
                        number,
                        name: item.objective,
                        target: item.config.description,
                        min_achievement: item.config.min_achievement,
                        target_monthly: vm.aspect === 'BRE' ? item.config.target.monthly_target :  item.config.min_achievement,
                        target_ongoing: vm.aspect === 'BRE' ? Math.round(item.config.target['target_' + curr.format('YYYYMM')]) : item.config.min_achievement,
                        total_target: item.config.target_amount,
                        target_yield: achievement.target_yield,
                        total_yield: achievement.total_yield,
                        percentage_month: Math.round(achievement.target_yield / Math.round(item.config.target['target_' + curr.format('YYYYMM')]) * 100),
                        percentage_project: Math.round((achievement.total_yield / item.config.target_amount)  * 100),
                        weight: Math.round(item.config.weight * 100),
                        predicate: achievement.evaluation,
                        key_result: keyResult,
                        wom: item.config.wom,
                        achievement,
                    }))
                })

                collection.push( Object.assign(Object.create(Performance), {
                    id: idx + 1,
                    is_footer: true,
                    weight: collection.reduce((a, b) => a + b.weight, 0),
                    name: 'Total',
                }))

                return collection
            }
            return []
        },
        tableColumns() {
            let columns = this.columns

            // some modifier.
            columns[1].title = this.perspectives[this.filters.perspective]
            columns[columns.length - 1].title = this.is_scoring ? 'Approval' : 'Action'

            return  _.filter(columns, (o) => ! this.excludes.includes(o.key))
        },
        currentSelectedMonth() {
            return this.filters.month === null ? this.defaultMonth : this.filters.month
        },
        defaultMonth() {
            let current = this.moment()

            if (current.isBetween(this.dateStart, this.dateEnd, 'month')) {
                current.subtract(1, 'months')
                if (current.isSameOrBefore(this.dateStart, 'month')) {
                    return current
                } else if (current.isSameOrAfter(this.dateEnd, 'month')) {
                    return this.dateEnd
                }

                return current
            } else if (current.isSameOrBefore(this.dateStart, 'month')) {
                return this.dateStart
            }

            return this.dateEnd
        },
        isMentor() {
            return this.$laravel.roles.performance == "mentor"
        },
    },
    data: () => ({
        colors,
        aspects,
        perspectives,
        columns,
        filters: {},
        drawer: {
            visible: false,
            obj: null,
            original: null,
            type: null,
        },
        objectives: [],
        achievements: {},
        loading: false,
        dateStart: null,
        dateEnd: null,
        borders: {
            waiting: 'border-danger',
            pending: 'border-warning',
            review: 'border-primary',
            approved: 'border-success',
        }
    }),
    created() {
        this.dateStart = this.moment(this.$laravel.training.date_start)
        this.dateEnd = this.moment(this.$laravel.training.date_end)

        this.filters = {
            month: this.defaultMonth,
            perspective: this.perspective
        }
    },
    methods: {
        evaluate(r) {
            this.drawer.visible = true
            this.drawer.obj = r
            this.drawer.original = this.objectives[r.index]
            this.drawer.type = 'evaluation'
        },
        implementation(r) {
            this.drawer.visible = true
            this.drawer.obj = r
            this.drawer.original = this.objectives[r.index]
            this.drawer.type = 'implementation'
        },
        setData(data) {
            this.achievements = data.achievements
            this.objectives = data.objectives
        },
        getObjectives() {
            this.loading = true
            this.$http
                .get(this.routeUri('api.performance.implementation'), {
                    params: {
                        cat: this.catCode,
                        user: this.user_hash,
                    }
                })
                .then(response => this.setData(response.data))
                .catch(err => this.handleXhrError(err))
                .finally(() => this.loading = false)
        },
        onChange(date, dateString) {
            this.filters.month = date
        },
        closeDrawer(){
            this.drawer = {visible: false, original: null, type: null, obj: null}
            this.getObjectives()
        },
        targetProject(r) {
            if (this.aspect === 'BRE')
                return r.percentage_project  + "%"

            return r.achievement.evaluation
        },
        targetMonth(r) {
            if (this.aspect === 'BRE')
                return r.percentage_month  + "%"

            return r.achievement.evaluation
        },
        back() {
            window.location.href = this.routeUri('admin.performance.scoring')
        }
    },
    watch: {
        'filters.perspective': {
            deep: false,
            handler: function(n,o) {
                this.getObjectives()
            }
        },
        period: function(val) {
            this.filters.month = this.moment(val, 'YYYYMM') || this.defaultMonth
        }
    }
}

</script>

<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="'Laporan KPI : ' + title" v-on="user_hash == null ? { } : { back: back }">
            <common-training-header :with-user="true" :in-header="true"></common-training-header>
        </a-page-header>

        <div style="margin: 20px 0;" class="text-right" v-if="showFilter">
            <a-dropdown-button>
                Perspektif : {{ perspectives[filters.perspective] }}
                <a-menu slot="overlay" @click="(e) => filters.perspective = e.key">
                    <a-menu-item v-for="(p, k) in perspectives" :key="k">{{ p }}</a-menu-item>
                </a-menu>
            </a-dropdown-button>

            <a-month-picker format="MMM YYYY" :defaultValue="defaultMonth" v-model="filters.month" />
        </div>

        <a-card type="inner" size="small">
           <a-skeleton :loading="loading" active>
               <a-table class="pcp-table" :dataSource="tableData" :columns="tableColumns" rowKey="id" :pagination="false"  :rowClassName="(r) => r.is_heading || r.is_footer ? 'row-heading' : borders[r.achievement.status] ">
                   <div slot-scope="r" slot="number" class="text-center text-small">
                       <strong>{{ r.number }}</strong>
                   </div>

                   <div slot-scope="r" slot="kpi" class="text-small text-left">
                       <template v-if="r.is_heading || r.is_footer">
                           <strong>{{ r.name }}</strong>
                       </template>
                       <template v-else>
                           {{ r.name }}
                       </template>
                   </div>

                   <div slot-scope="r" slot="weight" class="text-small text-center" v-show="! r.is_heading">
                        <strong>{{ r.weight }} %</strong>
                   </div>

                   <div slot-scope="r" slot="target" class="text-small text-left" v-show="! r.is_heading && ! r.is_footer">
                       {{ r.target }}
                   </div>

                   <div slot-scope="r" slot="monthly_target" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                        <strong>{{ number_format(r.target_ongoing) }}</strong>
                   </div>

                   <div slot-scope="r" slot="current_realization" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                        <strong>{{ number_format(r.target_yield) }}</strong>
                   </div>

                   <div slot-scope="r" slot="percentage_project" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                        <strong>{{ targetProject(r) }}</strong>
                   </div>

                   <div slot-scope="r" slot="percentage_month" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                        <strong>{{ targetMonth(r) }}</strong>
                   </div>

                   <div slot-scope="r" slot="predicate" class="text-small" v-show="! r.is_heading && ! r.is_footer">
                       <template v-if="! r.is_heading && ! r.is_footer">
                           <strong><a-badge class="text-small" :color="colors['_' + r.predicate]" :text="r.predicate.toString()" /></strong>
                       </template>
                   </div>

                   <div slot-scope="r" slot="action" class="text-small text-center" v-show="! r.is_heading && ! r.is_footer">
                        <a-button size="small" icon="interaction" @click="evaluate(r)" title="Evaluasi" v-if="!is_scoring || isMentor" />
                        <a-button size="small" type="primary" icon="export" :disabled="r.achievement.status === 'waiting' && is_scoring" :title="is_scoring ? 'Summary' : 'Pelaksanaan'" @click="implementation(r)" />
                   </div>
               </a-table>
           </a-skeleton>
        </a-card>

        <a-drawer :width="720" placement="right" :aspect="aspect" :closable="true" :visible="drawer.visible" @close="() => drawer = {visible: false, original: null, type: null, obj: null}">
            <template v-if="drawer.type === 'evaluation'">
                <a-card type="inner" size="small" :bordered="false">
                   <a-descriptions bordered>
                       <a-descriptions-item label="Kompetensi" span="3">
                           <strong>{{ aspects[aspect] }}</strong>
                       </a-descriptions-item>

                       <!-- -->
                       <a-descriptions-item label="Key Result Area" >
                           {{ drawer.obj.key_result}}
                       </a-descriptions-item>

                       <a-descriptions-item label="Sasaran" span="2">
                           {{ drawer.obj.name }}
                       </a-descriptions-item>

                       <a-descriptions-item label="Evaluasi Kinerja" span="3">
                           <div v-if="drawer.obj.achievement.note_progress != null && drawer.obj.achievement.note_progress != 'null'">
                               {{ drawer.obj.achievement.note_progress }}
                           </div>
                       </a-descriptions-item>

                       <a-descriptions-item label="Saran dan Perbaikan" span="3">
                           <div v-if="drawer.obj.achievement.note_suggestion != null && drawer.obj.achievement.note_suggestion != 'null'">
                               {{ drawer.obj.achievement.note_suggestion }}
                           </div>
                       </a-descriptions-item>

                       <a-descriptions-item label="Evaluasi Laporan" span="3">
                           <div v-if="drawer.obj.achievement.note_report != null && drawer.obj.achievement.note_report != 'null'">
                               {{ drawer.obj.achievement.note_report }}
                           </div>
                       </a-descriptions-item>
                   </a-descriptions>
                </a-card>
            </template>

            <template v-else-if="drawer.type === 'implementation'">
                <performance-scoring-business-form :user_hash="user_hash" :is_scoring="is_scoring" :aspect="aspects[aspect]" :info="drawer" :month="currentSelectedMonth" @handleClose="closeDrawer" />
            </template>
        </a-drawer>
    </div>
</template>
